import { ClearOutlined, QuestionCircleFilled, SearchOutlined } from "@ant-design/icons";
import isEqual from "lodash/isEqual";
import {
	Button, Card, Col, Collapse, Form, Image, Input, InputNumber, message,
	Modal, Radio, Row, Select,
	Table
} from "antd";
import 'antd/dist/antd.css';
import React, { useEffect, useRef, useState } from "react";
import { useParams } from 'react-router';
import { Link, useLocation } from 'react-router-dom';
import IneSeccion1 from '../../assets/img/credencial_a.png';
import IneSeccion3 from '../../assets/img/credencial_b.png';
import IneSeccion2 from '../../assets/img/credencial_c.png';
import IneSeccion4 from '../../assets/img/credencial_d.png';
import LogoLoader from '../../assets/img/loader.gif';
import useBusquedaContext from '../../context/useBusquedaContext';
import useDataContext from '../../context/useDataContext';
import "../../index.css";
import ExportCSV_PJ from '../../utils/ExportCSV_PJ';
import GraficasPJ from './GraficasPJ';

import cero from '../../assets/img/numeros/cero.png'; 
import uno from '../../assets/img/numeros/uno.png';
import dos from '../../assets/img/numeros/dos.png';
import tres from '../../assets/img/numeros/tres.png';
import cuatro from '../../assets/img/numeros/cuatro.png';
import cinco from '../../assets/img/numeros/cinco.png';
import seis from '../../assets/img/numeros/seis.png';
import siete from '../../assets/img/numeros/siete.png';
import ocho from '../../assets/img/numeros/ocho.png';
import nueve from '../../assets/img/numeros/nueve.png';
import minus from '../../assets/img/numeros/minus.png';
import plus from '../../assets/img/numeros/plus.png';

const { Panel } = Collapse;
const { Option } = Select;

const imagPoderUnion = {
    1: `${process.env.REACT_APP_API_URL}img/emblemaPoderUnion/PE.png`,
    2: `${process.env.REACT_APP_API_URL}img/emblemaPoderUnion/PL.png`,
    3: `${process.env.REACT_APP_API_URL}img/emblemaPoderUnion/PJ.png`,
    4: `${process.env.REACT_APP_API_URL}img/emblemaPoderUnion/EF.png`,
};

const imgCaptcha = [
	{ imgx: cero, altx: "Cero" },
	{ imgx: uno, altx: "Uno" },
	{ imgx: dos, altx: "Dos" },
	{ imgx: tres, altx: "Tres" },
	{ imgx: cuatro, altx: "Cuatro" },
	{ imgx: cinco, altx: "Cinco" },
	{ imgx: seis, altx: "Seis" },
	{ imgx: siete, altx: "Siete" },
	{ imgx: ocho, altx: "Ocho" },
	{ imgx: nueve, altx: "Nueve" },
	{ imgx: plus, altx: "Más"},
	{ imgx: minus, altx: "Menos"},
  ];

const titulos = [ " ",
  "Ministras y ministros de la Suprema Corte de Justicia de la Nación",
  "Magistradas y magistrados de la Sala Superior del Tribunal Electoral del Poder Judicial de la Federación",
  "Magistradas y magistrados del Tribunal de Disciplina Judicial",
  "Magistradas y magistrados de la Sala Regional del Tribunal Electoral del Poder Judicial de la Federación",
  "Magistradas y magistrados de Circuito",
  "Juezas y jueces de Distrito"
];

function PanelesPJ() {

	const {
		tiposCandidaturas,
		setTiposCandidaturas,
		secciones,
		setSecciones,
		estados, 
		setEstados,
		juecesDistrito, 
		setJuecesDistrito,
		magistradoSalaReg, 
		setMagistradoSalaReg,
		magistradoSalaSup, 
		setMagistradoSalaSup,
		magistradoTribDJ, 
		setMagistradoTribDJ,
		magistradoTrib, 
		setMagistradoTrib,
		ministroSupremaCorte, 
		setMinistroSupremaCorte,
		catPoderesUnion, 
		setCatPoderesUnion,
		jsonEtiquetas,
		entidades, 
		setEntidades
	} = useDataContext();

	const {
		cargadoExcel,
		setCargandoExcel,
	} = useBusquedaContext();

	const scrollToRef1 = useRef(null);
	const scrollToRef2 = useRef(null);

	const [cargando, setCargando] = useState(false);
	const location = useLocation();

	let { idEntidad, idSeccion } = useParams();
	const [idEntidadB, setidEntidadB] = useState(idEntidad && idEntidad !== undefined ? idEntidad : 0);
	const [idSeccionB, setIdSeccionB] = useState(idSeccion && idSeccion !== undefined  ? idSeccion : 0);

	
	const [candidatos1, setCandidatos1] = useState(ministroSupremaCorte.candidatos);
	const [candidatos2, setCandidatos2] = useState(magistradoSalaSup.candidatos);
	const [candidatos3, setCandidatos3] = useState(magistradoTribDJ.candidatos);
	const [candidatos4, setCandidatos4] = useState(magistradoSalaReg.candidatos);
	const [candidatos5, setCandidatos5] = useState(magistradoTrib.candidatos);
	const [candidatos6, setCandidatos6] = useState(juecesDistrito.candidatos);

	const [searchText, setSearchText] = useState(""); // Para almacenar el texto de búsqueda
	const [searchTextBoleta, setSearchTextBoleta] = useState(""); // Para almacenar el texto de búsqueda
	const [filteredData, setFilteredData] = useState([]); // Datos filtrados
	const [filteredDataByName, setFilteredDataByName] = useState([]); // Datos filtrados
	const [activeKey, setActiveKey] = useState(["0"]); // Key del panel a visualizar
	const [selectedEntidad, setSelectedEntidad] = useState(() => {
														if(idEntidad){
															const aux1 = Number(idEntidad);														
															if (aux1 >= 1 && aux1 <= 32) {
																return aux1;
															} else {
																return null;
															}
														} else {
															return null;
														}
													}); //Entidad seleccionada
	const [selectedSeccion, setSelectedSeccion] = useState(() => {
														if(idSeccion){
															const aux2 = Number(idSeccion);														
															if (aux2 >= 1 && aux2 <= 9999) {
																if(idEntidad){
																	const aux1 = Number(idEntidad);														
																	if (aux1 >= 1 && aux1 <= 32) {
																		return aux2;
																	} else {
																		return null;
																	}
																} else {
																	return null;
																}
															} else {
																return null;
															}
														} else {
															return null;
														}
													}); //Seccion seleccionada
	const [filteredSecciones, setFilteredSecciones] = useState([]); //Secciones filtradas por entidad
	const [sexo, setSexo] = useState(null); // Para almacenar el valor del sexo
	const [poder, setPoder] = useState(null); // Para almacenar el valor del poder de la unión
	const [idDistritoFederal, setIdDistritoFederal] = useState(null); //Id distrito encontrado por medio de la seccion
	const [idCircunscripcion,setIdCircunscripcion] = useState(null); // Para filtrado de Salas regionales
	const [idDistritoJudicial,setIdDistritoJudicial] = useState(null); // Para filtrado de Magistrad@s de Circuito y Juez@s Distrito
	
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [isModalUrl, setIsModalUrl] = useState(false);
	const [mensaje, setMensaje] = useState("");
	const [isModalCaptcha, setIsModalCaptcha] = useState(false);
	const [respuesta,setRespuesta] = useState(null);
	const [captchaQuestion, setCaptchaQuestion] = useState({answer: 0,
															num1: 0,
															num2: 0,
															operator: "+"
														   });
	const [linkToDownload, setLinkToDownload] = useState('');
	
	const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

	useEffect(() => {
		// Limpiar la URL si contiene caracteres adicionales
        const currentUrl = window.location.href;
        const baseUrl = window.location.origin + "/"; // Obtiene el dominio base con la barra final
        if (currentUrl !== baseUrl) {
            window.history.replaceState(null, null, baseUrl); // Reemplaza la URL actual con la URL limpia
        }
		
		// Verifica si selectedEntidad y selectedSeccion son válidos
		if (
		  selectedEntidad !== null &&
		  !isNaN(selectedEntidad) &&
		  selectedEntidad !== undefined &&
		  selectedSeccion !== null &&
		  !isNaN(selectedSeccion) &&
		  selectedSeccion !== undefined
		) {
		  // Actualiza la URL cuando selectedEntidad y selectedSeccion cambian
		  const newUrl = `/${selectedEntidad}/${selectedSeccion}`;
		  window.history.pushState({ path: newUrl }, '', newUrl);
		}
		
		let bandera = false;
		let aux1 = Number(idEntidad);
		let aux2 = Number(idSeccion);	

		if(aux1){														
			if (aux1 >= 1 && aux1 <= 32) {
				bandera = false;
				setMensaje("");
			} else {
				bandera = true;
				setMensaje("La información de entidad y sección obtenida por la URL es incorrecta.");
			}
		}else{
			if((idEntidad != null && !Number(idEntidad)) || Number(idEntidad) == 0){
				bandera = true;
				setMensaje("La información de entidad y sección obtenida por la URL es incorrecta.");
			}
		}

		if(aux2){
			if (aux1 && bandera == false) {
				if(aux2 >= 1 && aux2 <= 9999){								
					bandera = false;
					setMensaje("");
				} else {
					bandera = true;
					setMensaje("Se ha realizado una búsqueda por entidad, pero la información de la sección no es válida. Por favor, verifique los datos ingresados");
				}
			} else if(aux2 >= 1 && aux2 <= 9999){													
				bandera = true;
				setMensaje("La información de entidad y sección obtenida por la URL es incorrecta.");
			} else {
				bandera = true;
				setMensaje("La información de entidad y sección obtenida por la URL es incorrecta.");
			}
		}else{
			console.log("entro else sec");
			if (bandera == false) {
				if((idSeccion != null && !Number(idSeccion)) || Number(idSeccion) == 0 ){										
					bandera = true;
					setMensaje("Se ha realizado una búsqueda por entidad, pero la información de la sección no es válida. Por favor, verifique los datos ingresados en la URL");
				} 
			}
		}

		if(bandera){
			showModalUrl();
		}

	}, [selectedEntidad, selectedSeccion]);
	  

	useEffect(() => {
		// Al cargar la página, hacemos scroll hacia el elemento
		if (scrollToRef1.current) {
			scrollToRef1.current.scrollIntoView({ behavior: 'smooth' });
		}
	}, []);

	//aqui agregar el codigo para leer variables de la url
	useEffect(() => {

		inicializarDatos();

		if (ministroSupremaCorte?.candidatos && magistradoSalaSup?.candidatos && magistradoTribDJ?.candidatos&&
			magistradoSalaReg?.candidatos && magistradoTrib?.candidatos && juecesDistrito?.candidatos && entidades != null && secciones != null){
			
			if(selectedEntidad != null && selectedSeccion != null){
				verificaDatos();
			}

		  }

	}, [ministroSupremaCorte,magistradoSalaSup,magistradoTribDJ,magistradoSalaReg,magistradoTrib,juecesDistrito,entidades,secciones]);

	const columns = [
		{
			title: (
				<span>
					<Row justify="center">
						<Col>
							<Row justify="center">
								<Col style={{marginRight: "10px"}} > No. de lista en la boleta  </Col>
							</Row>
							<Row justify="center">
								<Col style={{marginLeft: "10px"}}>
									<Input
										id="busquedaNumero"
										placeholder="Buscar por número"
										value={searchTextBoleta}
										onChange={(e) => handleSearchBoleta(e.target.value)}
										suffix={<SearchOutlined style={{ color: "#D5007F" }}/>}
										style={{
											width: 200,
											textAlign: "left",
										}}
										onClick={(e) => e.stopPropagation()}
									/>
								</Col>
							</Row>
						</Col>
					</Row>
				</span>
				),
			dataIndex: 'numListaBoleta',
			key: 'numListaBoleta',
			sorter: (a, b) => a.numListaBoleta.localeCompare(b.numListaBoleta),
			width: "260px",
		},
		{
			title: "Poder que postula",
			dataIndex: "poderPostula",
			minWidth: "380px", 
			width: "auto",
			sorter: (a, b) => a.poderPostula.length - b.poderPostula.length,
			render: (text, record) =>{
				let content = null;

				// Verificamos si 'record.poderPostula' es un array
				if (Array.isArray(record.poderPostula)) {
					// Si es un array, mapeamos los valores para mostrar las imágenes
					content = record.poderPostula.map((valor) => (
					<Image
						key={valor}
						width={30}
						height={30}
						preview={false}
						src={imagPoderUnion[valor]}
						alt={`Emblema del poder ${valor}`}
						style={{ marginRight: '10px' }}
					/>
					));
				} else {
					// Si no es un array, mostramos el mensaje de "No hay poderes disponibles"
					content = <span>La candidatura no proporcionó información.</span>;
				}

				return (
					<Row justify="center">
					<Col span={14}>
						<div style={{ display: 'flex', justifyContent: 'center', gap: '10px', alignItems: 'center' }}>
						{content}
						</div>
					</Col>
					</Row>
				);
			},
		},
		{
			title: (
			<span>
				<Row justify="center">
					<Col>
						<Row justify="center">
							<Col style={{marginRight: "10px"}} > Nombre </Col>
						</Row>
						<Row>
							<Col style={{marginLeft: "10px"}}>
								<Input
									id="busquedaNombre"
									placeholder="Buscar por nombre"
									value={searchText}
									onChange={(e) => handleSearch(e.target.value)}
									suffix={<SearchOutlined style={{ color: "#D5007F" }}/>}
									style={{
										width: 200,
										textAlign: "left",
									}}
									onClick={(e) => e.stopPropagation()}
								/>
							</Col>
						</Row>
					</Col>
				</Row>
			</span>
			),
			dataIndex: "nombreCandidato",
			// Filtro de búsqueda de texto
			sorter: (a, b) => a.nombreCandidato.localeCompare(b.nombreCandidato),
			render: (text, record) => (
			<Row justify="center">
				<Col span={22}>
					<div style={{ textAlign: 'center' }}>
						<Link key={record.idCandidato}
						to={{ pathname: `/detalleCandidato/${record.idCandidato}/${record.idTipoCandidatura}`,
							state: { idCandidato: record.idCandidato, idTipoCandidatura: record.idTipoCandidatura,},}}>
						{text}
					</Link>
					</div>
				
				</Col>
				<Col span={2} className="col-FConsulta" style={{ marginRight: '0px'}}>
					<Link className="div-FConsulta" key={record.idCandidato}
							to={{ pathname: `/detalleCandidato/${record.idCandidato}/${record.idTipoCandidatura}`,
								state: { idCandidato: record.idCandidato, idTipoCandidatura: record.idTipoCandidatura,},}}>
						<div className="div-FConsulta">
							<div className="FConsulta" style={{ paddingLeft: '5px', paddingRight: '5px'}}>Consulta</div>
						</div>
					</Link>
				</Col>
			</Row>
			),
		},
	];

	const manejadorPaneles = (key) => {
		setActiveKey([key[1]]); // Establece el panel activo

		//Cagar paneles 1 a 3 no se hace el prefiltrado
		if(key[1] == 1){
			setFilteredData(candidatos1);
			setFilteredDataByName(candidatos1);
		}

		if(key[1] == 2){
			setFilteredData(candidatos2);
			setFilteredDataByName(candidatos2);
		}

		if(key[1] == 3){
			setFilteredData(candidatos3);
			setFilteredDataByName(candidatos3);
		}

		if(key[1] == 4){
			setFilteredData(candidatos4);
			setFilteredDataByName(candidatos4);
		}

		if(key[1] == 5){
			setFilteredData(candidatos5);
			setFilteredDataByName(candidatos5);
		}

		if(key[1] == 6){
			setFilteredData(candidatos6);
			setFilteredDataByName(candidatos6);
		}
		//setFilteredData(data);
		setSearchText(""); // Limpiar búsqueda cuando el Collapse se cierra

	};

	// Manejador de búsqueda input de la tabla
	const handleSearch = (value) => {
		setSearchText(value); // Actualiza el texto de búsqueda
		setSearchTextBoleta(null);

		if(value.length >= 1){
			// Filtra los datos cuando se escribe en el input
			setFilteredData(filteredDataByName && filteredDataByName.filter((item) =>
				item.nombreCandidato && item.nombreCandidato.toLowerCase().includes(value.toLowerCase())
			));
		}else{
			setFilteredData(filteredDataByName);
		}

	};


	// Manejador de búsqueda input de la tabla
	const handleSearchBoleta = (value) => {
		setSearchTextBoleta(value); // Actualiza el texto de búsqueda
		setSearchText(null);

		if(value.length >= 1){
			// Filtra los datos cuando se escribe en el input
			setFilteredData(filteredDataByName && filteredDataByName.filter((item) =>
				item.numListaBoleta && Number(item.numListaBoleta) == Number(value)
			));
		}else{
			setFilteredData(filteredDataByName);
		}

	};

	//manejador del la variable Entidad
	const handleChangeEntidad = (value) => {

		setSelectedEntidad(value);
		setSelectedSeccion(null);

	};

	//manejador del la variable seccion y distrito
	const handleSeccionChange = (value) => {

		setSelectedSeccion(value);

	};

	const handleSexoChange = (e) => {
		setSexo(e.target.value);
	};

	const handlePoderChange = (e) => {
		setPoder(e.target.value);
	};

	const resetForm = async () => {
		setCargando(true);
		setSelectedEntidad(null); // Reinicia la entidad seleccionada
		setSelectedSeccion(null); // Reinicia la sección seleccionada
		setIdCircunscripcion(null);
		setSexo(null); // Reinicia Sexo
		setPoder(null); // Reinicia poder de la union
		setSearchText(""); // Limpia el campo de búsqueda
		setFilteredData([]); // Vuelve a mostrar todos los datos
		setFilteredSecciones([]); // Limpia las secciones filtradas
		setActiveKey([0]); // restablece el panel activo
		setIdDistritoJudicial(null);
		//console.log(selectedEntidad);
		setCandidatos1(ministroSupremaCorte.candidatos);
		setCandidatos2(magistradoSalaSup.candidatos);
		setCandidatos3(magistradoTribDJ.candidatos);
		setCandidatos4(magistradoSalaReg.candidatos);
		setCandidatos5(magistradoTrib.candidatos);
		setCandidatos6(juecesDistrito.candidatos);
		await sleep(1000); 
		setCargando(false);
		form.resetFields(); //restablece todos los campos de un formulario a sus valores iniciales
	};

	const handleKeyPress = (e) => {
		// Permitir solo números
		if (!/[0-9]/.test(e.key)) {
			e.preventDefault();
		}
	};

	const handleKeyPressDos = (e) => {
		// Permitir solo números
		if (!/[0-9-]/.test(e.key) || (e.key === '-' && e.target.value.includes('-'))) {
			e.preventDefault();
		  }
	};

	const verificaDatos = async() => {
		setActiveKey([0])

		if (selectedEntidad !== null) {

			setCargando(true);
			//await sleep(200);
			preFiltrado();
		}else{
			form.validateFields().then(() => {
				console.log("Form requelido validado");
			}).catch((errorInfo) => {
				message.error("Debe seleccionar una Entidad");
			});
		}
	};

	const prevCandidatos = useRef({ 
		candidatos1: null, 
		candidatos2: null, 
		candidatos3: null, 
		candidatos4: null, 
		candidatos5: null, 
		candidatos6: null 
	});

	useEffect(() => {
		const nuevosCandidatos = { candidatos1, candidatos2, candidatos3, candidatos4, candidatos5, candidatos6 };

		if (!isEqual(prevCandidatos.current, nuevosCandidatos)) {
			// Verifica que ninguno de los candidatos sea null antes de cambiar "cargando"
			if (Object.values(nuevosCandidatos).every(c => c !== null)) {
				console.log("Todos los candidatos han sido asignados correctamente.");
				setCargando(false);
			}
	
			// Guardar los nuevos valores en prevCandidatos
			prevCandidatos.current = nuevosCandidatos;
		} else {
			setCargando(false);
		}
	}, [candidatos1, candidatos2, candidatos3, candidatos4, candidatos5, candidatos6]);
	

	const preFiltrado = async() => {

		let datoIdCircunscripcion = null;
		let datoIdDistritoFederal = null;
		let datoIdDistritoJudicial = null;

		// Si el idDistritoFederal es igual a los filtros asigna valor y sale del ciclo
		for (let i = 0; i < entidades.length; i++) {	
			// Si el idDistritoFederal es igual a los filtros asigna valor y sale del ciclo
			if ((Number(selectedEntidad) == Number(entidades[i].idEstado))) {
				setIdCircunscripcion(entidades[i].idCircunscripcion);
				datoIdCircunscripcion = entidades[i].idCircunscripcion;
				break;
			}
		}

		for (let i = 0; i < secciones.length; i++) {	
			// Si el idDistritoFederal es igual a los filtros asigna valor y sale del ciclo
			if ((Number(selectedEntidad) == Number(secciones[i].idEstado)) && (Number(selectedSeccion) == Number(secciones[i].seccion))) {
				setIdDistritoFederal(secciones[i].idDistritoFederal);
				datoIdDistritoFederal = secciones[i].idDistritoFederal;

				setIdDistritoJudicial(secciones[i].idDistritoJudicial);
				datoIdDistritoJudicial = secciones[i].idDistritoJudicial;

				break;
			}
		}

		//console.log("Filtrando Por idDistritoEleccion");
		//console.log(datoIdDistritoFederal);


		let candidatosAux1 = ministroSupremaCorte.candidatos;
		let candidatosAux2 = magistradoSalaSup.candidatos;
		let candidatosAux3 = magistradoTribDJ.candidatos;

		let candidatosAux4 = magistradoSalaReg.candidatos.filter(candidato => candidato.idCircunscripcionEleccion !== undefined && Number(candidato.idCircunscripcionEleccion) == Number(datoIdCircunscripcion));
		
		let candidatosAux5 = magistradoTrib.candidatos.filter(candidato => candidato.idEstadoEleccion !== undefined && Number(candidato.idEstadoEleccion) == Number(selectedEntidad));
		let candidatosAux6 = juecesDistrito.candidatos.filter(candidato => candidato.idEstadoEleccion !== undefined && Number(candidato.idEstadoEleccion) == Number(selectedEntidad));


		// Si "idDistritoFederal" no es nulo, filtramos los resultados por "idDistritoEleccion"
		if (datoIdDistritoJudicial !== null) {
			candidatosAux5 = candidatosAux5.filter(candidato => candidato.idDistritoJudicial !== undefined && Number(candidato.idDistritoJudicial) == Number(datoIdDistritoJudicial));
			candidatosAux6 = candidatosAux6.filter(candidato => candidato.idDistritoJudicial !== undefined && Number(candidato.idDistritoJudicial) == Number(datoIdDistritoJudicial));
		}

		// Si "sexo" no es nulo, filtramos los resultados por "sexo"
		if (sexo !== null) {
			candidatosAux1 = candidatosAux1.filter(candidato => candidato.sexo !== undefined && candidato.sexo == sexo);
			candidatosAux2 = candidatosAux2.filter(candidato => candidato.sexo !== undefined && candidato.sexo == sexo);
			candidatosAux3 = candidatosAux3.filter(candidato => candidato.sexo !== undefined && candidato.sexo == sexo);

			candidatosAux4 = candidatosAux4.filter(candidato => candidato.sexo !== undefined && candidato.sexo == sexo);
			candidatosAux5 = candidatosAux5.filter(candidato => candidato.sexo !== undefined && candidato.sexo == sexo);
			candidatosAux6 = candidatosAux6.filter(candidato => candidato.sexo !== undefined && candidato.sexo == sexo);
		}


		// Si "poder" no es nulo, filtramos los resultados por "idDistritoFederal"
		if (poder !== null) {
			candidatosAux1 = candidatosAux1.filter(candidato => Array.isArray(candidato.poderPostula) && candidato.poderPostula.includes(Number(poder)));
			candidatosAux2 = candidatosAux2.filter(candidato => Array.isArray(candidato.poderPostula) && candidato.poderPostula.includes(Number(poder)));
			candidatosAux3 = candidatosAux3.filter(candidato => Array.isArray(candidato.poderPostula) && candidato.poderPostula.includes(Number(poder)));

			candidatosAux4 = candidatosAux4.filter(candidato => Array.isArray(candidato.poderPostula) && candidato.poderPostula.includes(Number(poder)));
			candidatosAux5 = candidatosAux5.filter(candidato => Array.isArray(candidato.poderPostula) && candidato.poderPostula.includes(Number(poder)));
			candidatosAux6 = candidatosAux6.filter(candidato => Array.isArray(candidato.poderPostula) && candidato.poderPostula.includes(Number(poder)));
		}

		setCandidatos1(candidatosAux1);
		setCandidatos2(candidatosAux2);
		setCandidatos3(candidatosAux3);

		setCandidatos4(candidatosAux4);
		setCandidatos5(candidatosAux5);
		setCandidatos6(candidatosAux6);
		
		//await sleep(1000);
		//setCargando(false);

		if (scrollToRef2.current) {
			scrollToRef2.current.scrollIntoView({ behavior: 'smooth' });
		}

	};

	const [form] = Form.useForm();
	const [formUno] = Form.useForm();

	// Función para abrir el modal
	const showModal = () => {
		setIsModalVisible(true);
	};

	const showModalUrl = () => {
		setIsModalUrl(true);
	};

	const showModalCaptcha = () => {
		setIsModalCaptcha(true);
	};

	// Función para cerrar el modal
	const handleCancel = () => {
		setIsModalVisible(false);
	};

	const handleCancelUrl = () => {
		setIsModalUrl(false);
	};

	//Aqui Se inicializaran as variables de los listados 
	//Aqui se debere de agregar el codigo conficional si existen filtros para ejecutar las funciones correctas
	const inicializarDatos = () => {

		setCandidatos1(ministroSupremaCorte.candidatos);
		setCandidatos2(magistradoSalaSup.candidatos);
		setCandidatos3(magistradoTribDJ.candidatos);
		setCandidatos4(magistradoSalaReg.candidatos);
		setCandidatos5(magistradoTrib.candidatos);
		setCandidatos6(juecesDistrito.candidatos);

	};

	const handleCancelCaptcha = () => {
		setIsModalCaptcha(false);
	};


	const handleRespuestaChange = (value) => {

		setRespuesta(value);
		console.log(value)

	};

  // Función para generar una pregunta de CAPTCHA con números e imágenes
  const generateCaptchaQuestion = (e) => {

	e.preventDefault(); // Prevenimos que el enlace se abra inmediatamente
	setLinkToDownload(e.target.href); // Guardamos la URL del enlace
	formUno.resetFields();

    // Generar dos números aleatorios de hasta dos dígitos
    const num1 = Math.floor(Math.random() * 90) + 10; // Número entre 10 y 99
    const num2 = Math.floor(Math.random() * 90) + 10; // Número entre 10 y 99
    const operator = Math.random() > 0.5 ? '+' : '-'; // Aleatorio entre suma y resta
	
	let auxCaptcha =  {
		answer: operator === '+' ? num1 + num2 : num1 - num2,
		num1,
		num2,
		operator,
	  };

    setCaptchaQuestion(auxCaptcha);
	showModalCaptcha();

  };

	// Función para manejar la confirmación
	const verificaRespuesta = () => {
		console.log(respuesta);
		console.log(Number(respuesta));
		console.log(Number(captchaQuestion.answer));

		if(Number(captchaQuestion.answer) == Number(respuesta)){
			window.location.href = linkToDownload; // Redirigimos a la URL
			setIsModalCaptcha(false);
		}else{
			setIsModalCaptcha(false);
			setMensaje("Respuesta Incorrecta");
			showModalUrl(true);
		}

	};

  //para renderizar las imagenes del captcha
  const renderImage = (num) => {
    // Si el número es de dos dígitos, lo dividimos en sus partes
    if (num >= 10) {
      const tens = Math.floor(num / 10);
      const ones = num % 10;
      return (
        <>
          <img src={imgCaptcha[tens].imgx} alt={imgCaptcha[tens].altx} style={{ width: '100%',maxWidth: '60px',height: 'auto' }} />
          <img src={imgCaptcha[ones].imgx} alt={imgCaptcha[ones].altx} style={{ width: '100%',maxWidth: '60px',height: 'auto' }} />
        </>
      );
    }
    // Si es de un dígito, simplemente mostramos esa imagen
    return <img src={imgCaptcha[num].imgx} alt={imgCaptcha[num].altx} style={{ width: '100%',maxWidth: '60px',height: 'auto' }} />;
  };

	return (

	<>
		<div style={{marginTop: "15px", width: "100%", display: "flex", justifyContent: "center" }}>
			<div style={{ width: "80%" }}>
				<Row gutter={[16,16]} style={{minHeight: "150% !important"}}>
					<Col xs={24} sm={24} md={17} style={{marginRight: "5px"}}>
						<Card className="cardResponsabilidadUTTyPDP" style={{height: "100%", marginBottom: "15px"}}>
							<Col style={{alignItems: "justify", justifyContent: "justify"}}>
							<span>
								La información fue proporcionada de forma obligatoria por las personas candidatas a juzgadoras que participan 
								en el Proceso Electoral Extraordinario del Poder Judicial de la Federación, por lo tanto, 
								<b style={{color: "#000000"}}> el contenido es responsabilidad de las personas candidatas.&nbsp;</b>
								El INE promueve su difusión para que la ciudadanía conozca mejor a las candidaturas y tenga elementos que le permitan emitir un voto informado.
							</span>
							{/*<br></br>
							<Space>&nbsp;&nbsp;</Space>*/}
							</Col>
						</Card>
					</Col>
					
					{jsonEtiquetas && (
						<Col xs={24} sm={24} md={6} >
							<Card className="cardResponsabilidadUTTyPDP2 " style={{textAlign: 'center', border: '0px', height: "100%", backgroundColor: "#F3E9FD"}}>
								<Row style={{alignItems: "justify", justifyContent: "justify", marginBottom: "5px", fontSize: "12px" }}>
								{jsonEtiquetas[0].etiquetaDescripcion}:
								</Row>
								<Row style={{alignItems: "center", justifyContent: "center"}}>
									<b className="negro2-mensaje-consulta" style={{fontSize: '24px'}}>{jsonEtiquetas[0].cantidad}</b>
								</Row>
							</Card>
						</Col>
					)}

				</Row>

				
				<div className="row">
					<div className="col-xs-12 col-md-10 espaciador-top hide-pntr">
						<span>
						Este portal te permite consultar la información en línea, descargar la ficha de cada persona candidata y 
							<a						
								style={{color: "#D5007F"}}
								href={`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_URL_DATABASE}`}
								//onClick={generateCaptchaQuestion}
							>
								&nbsp;descargar la base de datos de todas las candidaturas.
							</a>
							&nbsp;
						</span>
						<br />
					</div>
				</div>

				<Row className="espaciador-top">
					<Col style={{ color: "#D5007F", fontWeight: "bold", fontSize:"16px" }} > Búsqueda por: </Col>
				</Row>
				<Row >
					<Col>Para iniciar con la búsqueda, selecciona tu entidad. Para conocer las candidaturas por las que votarás, introduce el número de sección electoral que está en tu credencial para votar. </Col>
				</Row>

				<Form id="filtrosForm"  form={form} >

			{/* ------------  Entidad y seccion ------------- */}
					<Row style={{ marginTop:"15px"}} gutter={16}>
						<Col style={{ marginRight: "10px"}}>
							<Row ref={scrollToRef1}>
								{/* Label para "Entidad" */}
								<label style={{ display: "block", fontWeight: "bold", marginBottom: 5 }}>
									<span  style={{ color: "red"}}>*</span> 
									Entidad:
								</label>
							</Row>
							<Row>
								{/* Input para "Entidad" */}
								<Form.Item id="entidad"	name="entidad" 
									rules={[{ required: true, message: "Debe seleccionar una entidad"},]}
									initialValue={selectedEntidad}
									
								>
									<Select  preview={false} id="entidad" onChange={handleChangeEntidad}  style={{ width: 200 }}
										placeholder="Selecciona" 
									>	
									
										{estados.map((estado) => (
										<Option  preview={false} key={estado.idEstado} value={estado.idEstado}>
											{estado.nombreEntidad}
										</Option>
										))}
									</Select>
								</Form.Item>
							</Row>					
						</Col>
						
						<Col >
							{/* Label con el ícono al lado */}
							<Row>
								<Col>
									<label style={{ display: "block", fontWeight: "bold", marginBottom: 5 }}>
									Sección Electoral:
									</label>
								</Col>
								<Col style={{ marginLeft: "10px"}}>
									<QuestionCircleFilled style={{ color: "#D5007F" }} onClick={showModal}/>
								</Col>
							</Row>
							<Row>
								{/* Input para "Sección Electoral" */}
								<InputNumber  id="seccion" onChange={handleSeccionChange} style={{ width: 200 }}
									placeholder="Ingresa la sección electoral"
									disabled={!selectedEntidad} // Deshabilitar si no hay entidad seleccionada
									value={selectedSeccion}
									min={1}
									maxLength={4}
									onKeyPress={handleKeyPress}
								
								>
								</InputNumber>
							</Row>
						</Col>
					</Row>
			{/* ------------  Sexo ------------- */}
					<Row style={{ marginTop:"20px"}} gutter={16}>
						<Col span={12}>
							{/* Label para "sexo" */}
							<label style={{ display: "block", fontWeight: "bold", marginBottom: 5 }} >
							Sexo:
							</label>
							{/* Input para "sexo" */}
							<Radio.Group id="sexo" onChange={handleSexoChange} value={sexo} >
							<Radio style={{fontWeight: "normal"}} value={"H"} label="Hombre">Hombre</Radio>
							<Radio style={{fontWeight: "normal"}} value={"M"} label="Mujer">Mujer</Radio>
							</Radio.Group>
						</Col>
					</Row>
			{/* ------------  Poder de la unión ------------- */}
					<Row style={{ marginTop:"20px"}} gutter={16}>
						<Col span={24}>
							{/* Label para "poder de la union" */}
							<label style={{ display: "block", fontWeight: "bold", marginBottom: 5 }}>
							Poder de la unión:
							</label>
							{/* Input para "poder de la union" */}
						</Col>
					</Row>
					<Row style={{width:"100%"}}>
						<Col style={{width:"100%"}}>
							<Radio.Group id="poder" onChange={handlePoderChange} value={poder} style={{ display: "flex"}}>
							<Row>
								<Col style={{ width: "250px" }}>
									<Radio value={1} style={{ display: "flex", alignItems: "center", marginTop: "5px"}}>
										<Row style={{ display: "flex", alignItems: "center", alignContent: "center" }}>
											<Col >
												<Image width={30} height={30} preview={false} src={`${process.env.REACT_APP_API_URL}img/emblemaPoderUnion/PE.png`} alt="Buscar información del Poder Ejecutivo"/>
											</Col>
											<Col style={{ marginLeft: "5px", fontWeight: "normal"}}>PODER EJECUTIVO</Col>
										</Row>
									</Radio>
								</Col>
								<Col style={{ width: "250px" }}>
									<Radio value={2} style={{ display: "flex", alignItems: "center", marginTop: "5px" }}>
										<Row style={{ display: "flex", alignItems: "center", alignContent: "center" }}>
											<Col >
												<Image width={30} height={30} preview={false} src={`${process.env.REACT_APP_API_URL}img/emblemaPoderUnion/PL.png`} alt="Buscar información del Poder Legislativo"/>
											</Col>
											<Col style={{ marginLeft: "5px", fontWeight: "normal"}}>PODER LEGISLATIVO</Col>
										</Row>
									</Radio>
								</Col>
								<Col style={{ width: "250px" }}>
									<Radio value={3} style={{ display: "flex", alignItems: "center", marginTop: "5px" }}>
										<Row style={{ display: "flex", alignItems: "center", alignContent: "center" }}>
											<Col>
												<Image width={30} height={30} preview={false} src={`${process.env.REACT_APP_API_URL}img/emblemaPoderUnion/PJ.png`} alt="Buscar información del Poder Judicial"/>
											</Col>
											<Col style={{ marginLeft: "5px", fontWeight: "normal" }}>PODER JUDICIAL</Col>
										</Row>
									</Radio>
								</Col>
								<Col style={{ width: "250px" }}>
									<Radio value={4} style={{ display: "flex", alignItems: "center", marginTop: "5px" }}>
										<Row style={{ display: "flex", alignItems: "center", alignContent: "center" }}>
											<Col>
												<Image width={30} height={30} preview={false} src={`${process.env.REACT_APP_API_URL}img/emblemaPoderUnion/EF.png`} alt="Buscar información  En Funciones"/>
											</Col>
											<Col style={{ marginLeft: "5px" , fontWeight: "normal"}}>EN FUNCIONES</Col>
										</Row>
									</Radio>
								</Col>
							</Row>
							</Radio.Group>

						</Col>
					</Row>
			{/* ------------  Botones ------------- */}
					<Row style={{ marginTop:"35px"}} gutter={16}>
						<Col span={12} style={{ textAlign:"right"}}>
							<Button style={{ backgroundColor: "#6C1773", color: "white", fontSize:"14px !important"}} onClick={resetForm} className="secondary-button">
							<ClearOutlined />
							<span style={{ marginLeft: "5px"}}>Limpiar campos</span>
							</Button>
						</Col>

						<Col span={12} style={{ textAlign:"left"}}>
							<Button style={{ backgroundColor: "#6C1773", color: "white", fontSize:"14px !important"}} onClick={verificaDatos} className="primary-button">
							<SearchOutlined />
							<span style={{ marginLeft: "5px"}}>Consultar</span>
							</Button>
						</Col>
					</Row>
				</Form>

				{!cargando ? (
					<>
			{/* ------------  Titulos paneles ------------- */}
					<Row style={{ marginTop:"35px"}} ref={scrollToRef2}>
						<Col style={{ color: "#D5007F", fontWeight: "bold", fontSize:"16px" }} >Resultados por cargo: </Col>
					</Row>
					<Row>
						<Col>Despliega para consultar la información de las candidaturas: </Col>
					</Row>

			{/* ------------  Paneles ------------- */}
				
					<div direction="vertical" style={{ width:"100%",marginRight:"50px"}} >

						<Collapse id="collapse1" collapsible="header" expandIconPosition="end" 
							className="custom-collapse color-1"
							style={{ marginTop:"15px", borderRadius: "10px"}} 
							onChange={(key) => manejadorPaneles(key)} 
							activeKey={activeKey}
						>
							<Panel header= {titulos[1]} key="1" className="custom-panel color2">	
								<div style={{ overflowX: "auto" }}>
								
									<Table columns={columns} dataSource={filteredData} className="custom-table color-1" bordered
										pagination={{
										pageSize: 10, 
										showSizeChanger: false,
										position: ["bottomCenter"], 
									}}
									/>
								</div>
								<div style={{ overflowX: "auto", textAlign: "right"}}>
									<ExportCSV_PJ
										csvData={filteredData}
										fileName={"Provisional" + Date.now()}
										tipoCandidatosBusqueda={"X"}
										tipoCandidatura={1}
										setCargandoExcel={setCargandoExcel}
									/>
								</div>
							</Panel>
						</Collapse>

						{/* ------------------------------------------------------------------------------------------------------------- */}

			{/* ---- Se cambia de posicion los datos del panel 3 arriba del panel 2, pero la posicion de colores se mantiene ---- */}
						<Collapse collapsible="header" expandIconPosition="end" 
							className="custom-collapse color-2"
							style={{borderRadius: "10px" } } 
							onChange={(key) => manejadorPaneles(key)} 
							activeKey={activeKey} 
						>

								<Panel header= {titulos[3]} key="3" className="custom-panel color2">
								<div style={{ overflowX: "auto" }}>
								
									<Table columns={columns} dataSource={filteredData} className="custom-table color-2" bordered
										pagination={{
										pageSize: 10, 
										showSizeChanger: false,
										position: ["bottomCenter"],
									}}
									/>
								</div>
								<div style={{ overflowX: "auto", textAlign: "right"}}>
									<ExportCSV_PJ
										csvData={filteredData}
										fileName={"Provisional" + Date.now()}
										tipoCandidatosBusqueda={"X"}
										tipoCandidatura={1}
										setCargandoExcel={setCargandoExcel}
									/>
								</div>
							</Panel>
						</Collapse>

						{/* ------------------------------------------------------------------------------------------------------------- */}

						<Collapse id="collapse2" collapsible="header" expandIconPosition="end"
							className="custom-collapse color-3"
							style={{borderRadius: "10px" } } 
							onChange={(key) => manejadorPaneles(key)} 
							activeKey={activeKey} 
						>

								<Panel header= {titulos[2]} key="2" className="custom-panel color1">
								<div style={{ overflowX: "auto" }}>
								
									<Table columns={columns} dataSource={filteredData} className="custom-table color-3" bordered
										pagination={{
										pageSize: 10, 
										showSizeChanger: false,
										position: ["bottomCenter"], 
									}}
									/>
								</div>
								<div style={{ overflowX: "auto", textAlign: "right"}}>
									<ExportCSV_PJ
										csvData={filteredData}
										fileName={"Provisional" + Date.now()}
										tipoCandidatosBusqueda={"X"}
										tipoCandidatura={1}
										setCargandoExcel={setCargandoExcel}
									/>
								</div>
							</Panel>
						</Collapse>

						{/* ------------------------------------------------------------------------------------------------------------- */}

						<Collapse collapsible="header" expandIconPosition="end" 
							className="custom-collapse color-4"
							style={{borderRadius: "10px" } } 
							onChange={(key) => manejadorPaneles(key)} 
							activeKey={activeKey} 
						>

							<Panel header= {titulos[4]} key="4" className="custom-panel color2" >
								<div style={{ overflowX: "auto" }}>
								
									<Table columns={columns} dataSource={filteredData} className="custom-table color-4" bordered
										pagination={{
										pageSize: 10, 
										showSizeChanger: false,
										position: ["bottomCenter"], 
									}}
									/>
								</div>
								<div style={{ overflowX: "auto", textAlign: "right"}}>
									<ExportCSV_PJ
										csvData={filteredData}
										fileName={"Provisional" + Date.now()}
										tipoCandidatosBusqueda={"X"}
										tipoCandidatura={1}
										setCargandoExcel={setCargandoExcel}
									/>
								</div>
							</Panel>
						</Collapse>

						{/* ------------------------------------------------------------------------------------------------------------- */}

						<Collapse collapsible="header" expandIconPosition="end" 
							className="custom-collapse color-5"
							style={{borderRadius: "10px" } } 
							onChange={(key) => manejadorPaneles(key)}
							activeKey={activeKey} 
						>

							<Panel header= {titulos[5]} key="5" className="custom-panel color2" >
								<div style={{ overflowX: "auto" }}>
								
									<Table columns={columns} dataSource={filteredData} className="custom-table color-5" bordered
										pagination={{
										pageSize: 10, 
										showSizeChanger: false,
										position: ["bottomCenter"], 
									}}
									/>
								</div>
								<div style={{ overflowX: "auto", textAlign: "right"}}>
									<ExportCSV_PJ
										csvData={filteredData}
										fileName={"Provisional" + Date.now()}
										tipoCandidatosBusqueda={"X"}
										tipoCandidatura={1}
										setCargandoExcel={setCargandoExcel}
									/>
								</div>
							</Panel>
						</Collapse>

						{/* ------------------------------------------------------------------------------------------------------------- */}

						<Collapse collapsible="header" expandIconPosition="end" 
							className="custom-collapse color-6"
							onChange={(key) => manejadorPaneles(key)} 
							activeKey={activeKey} 
							style={{ marginBottom:"30px", borderRadius: "10px"}}
						>

							<Panel header= {titulos[6]} key="6" className="custom-panel color2" >
								<div style={{ overflowX: "auto" }}>
								
									<Table columns={columns} dataSource={filteredData} className="custom-table color-6" bordered
										pagination={{
										pageSize: 10, 
										showSizeChanger: false,
										position: ["bottomCenter"], 
									}}
									/>
								</div>
								<div style={{ overflowX: "auto", textAlign: "right"}}>
									<ExportCSV_PJ
										csvData={filteredData}
										fileName={"Provisional" + Date.now()}
										tipoCandidatosBusqueda={"X"}
										tipoCandidatura={1}
										setCargandoExcel={setCargandoExcel}
									/>
								</div>
							</Panel>
						</Collapse>
						
						<GraficasPJ entidad={selectedEntidad} />

					</div>
					</>
				):(<>			
					<Row  style={{display: 'flex', justifyContent: 'center', width: '100%', marginTop: '50px'}}>
						<img className="img-responsiva" src={LogoLoader}  width={80} height={80} preview={false}/>
					</Row>
				</>)}
			</div>
		</div>

		<Modal title={<div style={{display: 'flex', justifyContent: 'center', width: '100%'}}>
						<span className="roboto-medium-20-rosa" style={{textAlign: 'center'}}>
							¿Dónde consultar tu sección electoral?
						</span>
					</div>} 
			visible={isModalVisible}
			footer={null} onCancel={handleCancel} centered width={600} >
			
			<Row align="center" span="6">
				<Col className="img-modal-seccion">
					<img className="img-responsiva" src={IneSeccion1} />
				</Col>
				<Col className="img-modal-seccion">
					<img className="img-responsiva" src={IneSeccion2} />
				</Col>			
			</Row>
			<Row align="center" span="6">
				<Col className="img-modal-seccion">
					<img className="img-responsiva" src={IneSeccion3} />
				</Col>
				<Col className="img-modal-seccion">
					<img className="img-responsiva" src={IneSeccion4} />
				</Col>
			</Row>
			<Row align="center" style={{ textAlign: "center", marginBottom: "20px" }}>
				<Button type="primary" onClick={handleCancel}
					style={{display: "block", margin: "0 auto", marginBottom: "20px"}}>
					Cerrar
				</Button>
			</Row>
		</Modal>

		<Modal title={<div style={{display: 'flex', justifyContent: 'center', width: '100%'}}>
						<span className="roboto-medium-20-rosa" style={{textAlign: 'center'}}>
							Información incorrecta
						</span>
					</div>} 
			visible={isModalUrl}
			footer={null} onCancel={handleCancelUrl} centered width={600} >
			
			<Row align="center">
				<Col style={{ marginLeft: "15px", marginRight: "15px" }}>
					<span style={{ textAlign: "center" }} >
						{mensaje}
					</span>
				</Col>		
			</Row>
			<Row align="center" style={{ textAlign: "center", marginTop: "20px",marginBottom: "20px" }}>
				<Button type="primary" onClick={handleCancelUrl}
					style={{display: "block", margin: "0 auto", marginBottom: "20px"}}>
					Cerrar
				</Button>
			</Row>
		</Modal>

		<Modal title={<div style={{display: 'flex', justifyContent: 'center', width: '100%'}}>
						<span className="roboto-medium-20-rosa" style={{textAlign: 'center'}}>
							Verificación de seguridad
						</span>
					</div>} 
			visible={isModalCaptcha}
			footer={null} onCancel={handleCancelCaptcha} centered width={600} >
			<Form id="formCaptcha" form={formUno}>

				<Row align="center" style={{marginTop: "10px" }}>
					<Col>
						{renderImage(captchaQuestion.num1)}
					</Col>
					<Col>
						<img src={captchaQuestion.operator === '+' ? imgCaptcha[10].imgx : imgCaptcha[11].imgx}
							alt={captchaQuestion.operator === '+' ? imgCaptcha[10].altx : imgCaptcha[11].altx}
							style={{ width: '100%',maxWidth: '60px',height: 'auto' }}
						/>
					</Col>
					<Col>
						{renderImage(captchaQuestion.num2)}
					</Col>		
				</Row>
								
				<Form.Item id="respuestaX"	name="respuestaX" 
							rules={[{ required: true, message: "Debe seleccionar una entidad"},]}
							initialValue={null}
				>
					<Row align="center" style={{marginTop: "15px" }}>
						<Col style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
							<label style={{ display: "block", fontWeight: "bold", marginBottom: 5 }}>
								Ingresa tu respuesta:
							</label>
						</Col>
						<Col style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
							<InputNumber  id="respuestaX" name="respuestaX"
								onChange={handleRespuestaChange}
								placeholder="respuesta"
								//value={respuesta}
								maxLength={4}
								onKeyPress={handleKeyPressDos}
								style={{ width: 100, marginLeft: "10px"}}
							/>
						</Col>
					</Row>
				</Form.Item>

				<Row align="center" style={{ textAlign: "center", marginTop: "20px",marginBottom: "20px" }}>
					<Button type="primary" onClick={verificaRespuesta}
						style={{display: "block", margin: "0 auto", marginBottom: "20px"}}>
						Verificar
					</Button>
				</Row>
			</Form>
		</Modal>

		</>
	);

}

export default PanelesPJ;
